import { render, staticRenderFns } from "./MeasurementByInstitution.vue?vue&type=template&id=da915548&scoped=true"
import script from "./MeasurementByInstitution.vue?vue&type=script&lang=js"
export * from "./MeasurementByInstitution.vue?vue&type=script&lang=js"
import style0 from "./MeasurementByInstitution.vue?vue&type=style&index=0&id=da915548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da915548",
  null
  
)

export default component.exports